const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image['src']);
	return widths
		.filter((width) => width <= image['width'])
		.map((width) => {
			imageUrl.searchParams.set('width', width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(', ');
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image['preview_image'];
	const newImage = new Image(previewImage['width'], previewImage['height']);
	newImage.className = classes;
	newImage.alt = image['alt'] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage['src'];
	newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
	newImage.loading = 'lazy';
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
		wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
			input.addEventListener('click', (event) => {
				const primaryImage = wrapper.querySelector('.media--first');
				const secondaryImage = wrapper.querySelector('.media--second');
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector('.js-color-swatches-link')
						.setAttribute('href', event.currentTarget.dataset.variantLink);
					if (wrapper.querySelector('.card__add-to-cart')) {
						wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
							event.currentTarget.dataset.variantLink.split('variant=')[1];
					}
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
						const variant = product.variants.filter(
							(item) => item.featured_media != null && item.options.includes(currentColor),
						)[0];
						if (variant) {
							const newPrimaryImage = createImageElement(
								variant['featured_media'],
								primaryImage.className,
								primaryImage.sizes,
								product.title,
							);

							if (newPrimaryImage.src !== primaryImage.src) {
								let flag = false;
								if (secondaryImage) {
									const secondaryImagePathname = new URL(secondaryImage.src).pathname;
									const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

									if (secondaryImagePathname == newPrimaryImagePathname) {
										primaryImage.remove();
										secondaryImage.classList.remove('media--second');
										secondaryImage.classList.add('media--first');
										flag = true;
									}
								}
								if (flag == false) {
									primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: 'ease-in', fill: 'forwards' })
										.finished;
									setTimeout(function () {
										primaryImage.replaceWith(newPrimaryImage);
										newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
										if (secondaryImage) {
											secondaryImage.remove();
										}
									}, 200);
								}
							}
						}
					});
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener('shopify:section:load', function () {
		checkSwatches();
	});
}

const checkPricingButtons = () => {
	document.addEventListener('click', (e) => {
		const button = e.target.closest('.card__pricing--button');
		if (!button) return;

		const variantId = button.dataset.variantId;
		if (!variantId || button.classList.contains('is-loading')) return;

		// Set loading state
		button.classList.add('is-loading');
		button.disabled = true;

		const cart = document.querySelector('cart-drawer');
		const sections = cart.getSectionsToRender().map((s) => s.id);

		const formData = new FormData();
		formData.append('id', variantId);
		formData.append('quantity', 1);
		formData.append('sections', sections);
		formData.append('sections_url', window.location.pathname);

		const config = fetchConfig('javascript');
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		delete config.headers['Content-Type'];
		config.body = formData;

		fetch(routes.cart_add_url, config)
			.then((res) => res.json())
			.then((response) => {
				button.classList.remove('is-loading');
				if (response.status) {
					console.error('Add to cart error:', response.description);
					button.disabled = false;
					return;
				}
				// Update cart drawer contents without opening it
				cart.classList.remove('is-empty');
				const drawerInner = cart.querySelector('.drawer__inner');
				if (drawerInner) drawerInner.classList.remove('is-empty');
				cart.getSectionsToRender().forEach((section) => {
					const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
					if (el) {
						el.innerHTML = cart.getSectionInnerHTML(response.sections[section.id], section.selector);
					}
				});
				// Show added state
				button.classList.add('is-added');
				setTimeout(() => {
					button.classList.remove('is-added');
					button.disabled = false;
				}, 2000);
			})
			.catch((err) => {
				console.error(err);
				button.classList.remove('is-loading');
				button.disabled = false;
			});
	});
};

(function () {
	colorSwatches();
	checkPricingButtons();
})();
